/**
 * Every portal in this app is appended to `document.body`, i.e. OUTSIDE the
 * `#mos-pg-bva` wrapper in src/app/Root.tsx. Tailwind is scoped to
 * `:is(#mos-pg-bva, [data-mos-pg-bva-portal])` (see tailwind.config.js) so
 * that utilities keep applying to portaled content without being re-parented
 * into the app's DOM subtree (re-parenting would risk changing the containing
 * block for these portals' `position: fixed` overlays).
 *
 * Always create body-level portal containers with this helper instead of a
 * bare `document.createElement('div')`.
 */
export const PORTAL_ATTRIBUTE = 'data-mos-pg-bva-portal'

export const createPortalContainer = (): HTMLDivElement => {
  const container = document.createElement('div')
  container.setAttribute(PORTAL_ATTRIBUTE, '')
  return container
}
